/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Bedclothes(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="7.312,2.238 1.349,2.239 0.861,2.812 0.87,1 7.312,1" />
            <g>
                <polygon points="0,12 8,12 8,3 2.285,3 2.285,5.375 0,5.375" />
                <polygon points="0.208,4.688 1.62,4.688 1.62,3" />
            </g>
        </SvgIcon>
    );
}

Bedclothes.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Bedclothes;
